<template>
  <div class="popup-block">
    <div class="pop-backdrop"></div>
    <main class="popup-container">
      <header class="pop-title">{{config.title}}</header>
      <div class="pop-content">{{config.content}}</div>
      <footer class="pop-btns">
        <div class="pop-btn" @click="cancel">放弃</div>
        <div class="pop-btn active" @click="ok">允许</div>
      </footer>
    </main>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  methods: {
    cancel() {
      this.remove()
      this.config.cancel()
    },
    ok() {
      this.remove()
      this.config.ok()
    },
    remove () {
      document.body.removeChild(document.getElementsByClassName('popup-block')[0])
    }
  }
}
</script>


<style lang="stylus" scoped>
.pop-backdrop
  position absolute
  top 0
  left 0
  bottom 0
  right 0
  background-color rgba(0,0,0,0.5)
.popup-container
  position absolute
  width 200px
  top 50%
  left 50%
  transform translate(-50%, -50%)
  background-color #ffffff
  display flex
  flex-direction column
  .pop-title
    height 40px
    font-size 16px
    line-height 40px
    padding-left 15px
  .pop-content
    min-height 50px
    font-size 12px
    padding 10px 20px
    color #333333
  .pop-btns
    padding 10px
    display flex
    justify-content space-around
    .pop-btn
      background-color #ffffff
      font-size 14px
      padding 10px
      color #999999
    .active
      color #1dbbd8
</style>

